var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProgressbarVertragUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_97"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_96"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_95"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_94"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_93"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_92"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_91"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_90"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_89"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_88"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_87"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_86"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_85"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_84"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_83"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_82"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_81"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_80"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_79"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_78"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_77"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_76"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_75"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_74"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_73"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_72"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_71"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_70"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_69"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_68"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_67"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_66"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_65"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_64"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_63"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_62"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_61"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_60"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150,19C77.767,19,19,77.767,19,150s58.767,131,131,131s131-58.767,131-131S222.233,19,150,19z  M214.649,229.927c0,4.367-3.552,7.922-7.92,7.922H93.271c-4.368,0-7.922-3.555-7.922-7.922v-154.1 c0-4.366,3.554-7.921,7.922-7.921h41.285l14.245-21.385c0.404-0.602,1.077-0.964,1.801-0.964s1.397,0.362,1.801,0.964 l14.245,21.385h40.082c4.368,0,7.92,3.555,7.92,7.921V229.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M206.729,72.23h-37.197l13.983,20.99c0.313,0.376,0.498,0.857,0.498,1.383 c0,1.195-0.957,2.171-2.167,2.159h-0.008H167.61v49.532c0,3.41-2.661,3.41-3.94,3.41h-26.136c-1.28,0-3.942,0-3.942-3.41V96.763 h-14.227c-0.798,0-1.532-0.438-1.906-1.14c-0.374-0.702-0.334-1.555,0.105-2.219l14.111-21.173H93.271 c-1.985,0-3.602,1.613-3.602,3.597v154.1c0,1.983,1.616,3.599,3.602,3.599h113.459c1.985,0,3.6-1.615,3.6-3.599v-154.1 C210.329,73.843,208.715,72.23,206.729,72.23z M141.695,188.354c1.64,0.208,3.56,1.567,4.033,4.749l0.261,1.801 c0.452,3.081,0.913,6.268,1.5,9.192c0.072,0.353,0.149,0.587,0.214,0.734c0.188-0.1,0.463-0.287,0.768-0.593 c0.163-0.162,0.338-0.349,0.527-0.547c1.483-1.564,3.513-3.71,6.044-3.262c1.001,0.176,2.394,0.849,3.35,3.051 c0.146,0.331,0.288,0.666,0.429,1.002c0.502,1.196,1.427,3.378,2.04,3.82c0.19-0.079,0.746-0.391,1.703-1.577 c0.651-0.811,1.244-1.558,1.781-2.239c2.987-3.77,4.358-5.505,6.401-5.505c0.015,0,0.028,0,0.048,0 c0.698,0.009,1.716,0.26,2.574,1.407c1.376,1.824,2.809,4.148,2.866,4.246c0.625,1.017,0.309,2.346-0.71,2.971 c-1.015,0.626-2.345,0.31-2.971-0.706c-0.011-0.019-0.989-1.601-2.044-3.093c-0.709,0.754-1.753,2.075-2.771,3.362 c-0.551,0.69-1.149,1.449-1.813,2.27c-0.712,0.881-2.872,3.572-5.665,3.17c-2.87-0.404-4.168-3.475-5.423-6.442 c-0.139-0.324-0.272-0.646-0.412-0.961c-0.082-0.192-0.155-0.329-0.213-0.423c-0.607,0.331-1.616,1.395-2.077,1.882 c-0.218,0.231-0.422,0.446-0.607,0.631c-1.634,1.633-3.513,2.284-5.154,1.789c-1.116-0.337-2.563-1.329-3.124-4.138 c-0.606-3.039-1.079-6.281-1.538-9.419l-0.261-1.791c-0.073-0.508-0.209-0.821-0.311-0.988c-0.102,0.109-0.239,0.299-0.37,0.604 c-1.208,2.858-7.371,20.089-7.435,20.264c-0.313,0.885-1.145,1.435-2.032,1.435c-0.24,0-0.487-0.042-0.728-0.127 c-1.123-0.402-1.71-1.638-1.31-2.762c0.259-0.715,6.271-17.524,7.525-20.494C137.753,189.396,139.677,188.088,141.695,188.354z  M106.036,110.66h18.857c1.192,0,2.159,0.967,2.159,2.162c0,1.192-0.967,2.16-2.159,2.16h-18.857 c-1.197,0-2.161-0.968-2.161-2.16C103.875,111.627,104.839,110.66,106.036,110.66z M106.036,127.665h18.857 c1.192,0,2.159,0.965,2.159,2.16s-0.967,2.161-2.159,2.161h-18.857c-1.197,0-2.161-0.967-2.161-2.161 S104.839,127.665,106.036,127.665z M106.036,144.669h18.857c1.192,0,2.159,0.966,2.159,2.16c0,1.195-0.967,2.162-2.159,2.162 h-18.857c-1.197,0-2.161-0.967-2.161-2.162C103.875,145.636,104.839,144.669,106.036,144.669z M103.875,161.608 c0-1.193,0.964-2.161,2.161-2.161h29.896c1.196,0,2.163,0.967,2.163,2.161c0,1.194-0.967,2.162-2.163,2.162h-29.896 C104.839,163.77,103.875,162.802,103.875,161.608z M178.489,223.24h-57.506c-1.193,0-2.161-0.968-2.161-2.161 s0.968-2.161,2.161-2.161h57.506c1.193,0,2.161,0.968,2.161,2.161S179.683,223.24,178.489,223.24z M194.695,163.77H148.59 c-1.191,0-2.159-0.968-2.159-2.162c0-1.193,0.968-2.161,2.159-2.161h46.105c1.188,0,2.16,0.967,2.16,2.161 C196.855,162.802,195.884,163.77,194.695,163.77z M194.695,148.992h-18.86c-1.194,0-2.161-0.967-2.161-2.162 c0-1.194,0.967-2.16,2.161-2.16h18.86c1.188,0,2.16,0.966,2.16,2.16C196.855,148.024,195.884,148.992,194.695,148.992z  M194.695,131.986h-18.86c-1.194,0-2.161-0.967-2.161-2.161s0.967-2.16,2.161-2.16h18.86c1.188,0,2.16,0.965,2.16,2.16 S195.884,131.986,194.695,131.986z M194.695,114.982h-18.86c-1.194,0-2.161-0.968-2.161-2.16c0-1.195,0.967-2.162,2.161-2.162 h18.86c1.188,0,2.16,0.967,2.16,2.162C196.855,114.014,195.884,114.982,194.695,114.982z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#137F7B",
    d: "M164.335,72.23l-2.878-4.324l-10.855-16.29l-10.855,16.29l-2.877,4.324l-13.468,20.211h11.581 c0.502,0,1.541,0,2.315,0.833c0.757,0.808,0.688,1.762,0.644,2.331c-0.011,0.173-0.025,0.389-0.025,0.655v49.121h25.37V96.261 c0-0.268-0.014-0.482-0.024-0.655c-0.043-0.569-0.113-1.522,0.644-2.331c0.771-0.833,1.814-0.833,2.316-0.833h11.581 L164.335,72.23z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M150,11C73.355,11,11,73.355,11,150s62.355,139,139,139s139-62.355,139-139S226.645,11,150,11z M150,281 c-72.233,0-131-58.767-131-131S77.767,19,150,19s131,58.767,131,131S222.233,281,150,281z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M178.489,218.918h-57.506c-1.193,0-2.161,0.968-2.161,2.161s0.968,2.161,2.161,2.161h57.506 c1.193,0,2.161-0.968,2.161-2.161S179.683,218.918,178.489,218.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M206.729,67.906h-40.082l-14.245-21.385c-0.403-0.602-1.077-0.964-1.801-0.964s-1.396,0.362-1.801,0.964 l-14.245,21.385H93.271c-4.368,0-7.922,3.555-7.922,7.921v154.1c0,4.367,3.554,7.922,7.922,7.922h113.459 c4.368,0,7.92-3.555,7.92-7.922v-154.1C214.649,71.461,211.098,67.906,206.729,67.906z M136.869,72.23l2.877-4.324l10.855-16.29 l10.855,16.29l2.878,4.324l13.468,20.211h-11.581c-0.502,0-1.545,0-2.316,0.833c-0.757,0.809-0.687,1.762-0.644,2.331 c0.011,0.173,0.024,0.387,0.024,0.655v49.121h-25.37V96.261c0-0.266,0.015-0.482,0.025-0.655 c0.044-0.569,0.113-1.523-0.644-2.331c-0.774-0.833-1.813-0.833-2.315-0.833h-11.581L136.869,72.23z M210.329,229.927 c0,1.983-1.614,3.599-3.6,3.599H93.271c-1.985,0-3.602-1.615-3.602-3.599v-154.1c0-1.984,1.616-3.597,3.602-3.597h38.405 l-14.111,21.173c-0.439,0.664-0.479,1.517-0.105,2.219c0.374,0.703,1.108,1.14,1.906,1.14h14.227v49.532 c0,3.41,2.662,3.41,3.942,3.41h26.136c1.279,0,3.94,0,3.94-3.41V96.763h14.229h0.008c1.21,0.012,2.167-0.964,2.167-2.159 c0-0.526-0.186-1.007-0.498-1.383l-13.983-20.99h37.197c1.985,0,3.6,1.613,3.6,3.597V229.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M106.036,114.982h18.857c1.192,0,2.159-0.968,2.159-2.16c0-1.195-0.967-2.162-2.159-2.162h-18.857 c-1.197,0-2.161,0.967-2.161,2.162C103.875,114.014,104.839,114.982,106.036,114.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M106.036,131.986h18.857c1.192,0,2.159-0.967,2.159-2.161s-0.967-2.16-2.159-2.16h-18.857 c-1.197,0-2.161,0.965-2.161,2.16S104.839,131.986,106.036,131.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M106.036,148.992h18.857c1.192,0,2.159-0.967,2.159-2.162c0-1.194-0.967-2.16-2.159-2.16h-18.857 c-1.197,0-2.161,0.966-2.161,2.16C103.875,148.024,104.839,148.992,106.036,148.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M138.095,161.608c0-1.193-0.967-2.161-2.163-2.161h-29.896c-1.197,0-2.161,0.967-2.161,2.161 c0,1.194,0.964,2.162,2.161,2.162h29.896C137.128,163.77,138.095,162.802,138.095,161.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M194.695,110.66h-18.86c-1.194,0-2.161,0.967-2.161,2.162c0,1.192,0.967,2.16,2.161,2.16h18.86 c1.188,0,2.16-0.968,2.16-2.16C196.855,111.627,195.884,110.66,194.695,110.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M194.695,127.665h-18.86c-1.194,0-2.161,0.965-2.161,2.16s0.967,2.161,2.161,2.161h18.86 c1.188,0,2.16-0.967,2.16-2.161S195.884,127.665,194.695,127.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M194.695,144.669h-18.86c-1.194,0-2.161,0.966-2.161,2.16c0,1.195,0.967,2.162,2.161,2.162h18.86 c1.188,0,2.16-0.967,2.16-2.162C196.855,145.636,195.884,144.669,194.695,144.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M194.695,159.448H148.59c-1.191,0-2.159,0.967-2.159,2.161c0,1.194,0.968,2.162,2.159,2.162h46.105 c1.188,0,2.16-0.968,2.16-2.162C196.855,160.415,195.884,159.448,194.695,159.448z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M129.268,212.16c-0.4,1.125,0.187,2.36,1.31,2.762c0.24,0.085,0.487,0.127,0.728,0.127 c0.888,0,1.72-0.55,2.032-1.435c0.063-0.175,6.227-17.406,7.435-20.264c0.131-0.305,0.269-0.496,0.37-0.604 c0.102,0.167,0.237,0.48,0.311,0.988l0.261,1.791c0.459,3.139,0.932,6.381,1.538,9.419c0.562,2.809,2.008,3.801,3.124,4.138 c1.642,0.495,3.521-0.156,5.154-1.789c0.186-0.185,0.39-0.4,0.607-0.631c0.461-0.487,1.47-1.551,2.077-1.882 c0.058,0.094,0.131,0.23,0.213,0.423c0.14,0.315,0.273,0.637,0.412,0.961c1.255,2.967,2.553,6.039,5.423,6.442 c2.793,0.401,4.953-2.29,5.665-3.17c0.663-0.821,1.262-1.58,1.813-2.27c1.018-1.288,2.062-2.608,2.771-3.362 c1.055,1.492,2.033,3.074,2.044,3.093c0.626,1.016,1.956,1.333,2.971,0.706c1.019-0.625,1.335-1.954,0.71-2.971 c-0.058-0.098-1.49-2.422-2.866-4.246c-0.858-1.147-1.876-1.398-2.574-1.407c-0.02,0-0.033,0-0.048,0 c-2.043,0-3.414,1.735-6.401,5.505c-0.537,0.681-1.13,1.429-1.781,2.239c-0.957,1.186-1.513,1.499-1.703,1.577 c-0.613-0.442-1.538-2.624-2.04-3.82c-0.141-0.337-0.282-0.671-0.429-1.002c-0.956-2.203-2.349-2.875-3.35-3.051 c-2.531-0.448-4.561,1.698-6.044,3.262c-0.189,0.198-0.364,0.385-0.527,0.547c-0.305,0.306-0.579,0.493-0.768,0.593 c-0.064-0.147-0.142-0.382-0.214-0.734c-0.587-2.925-1.048-6.112-1.5-9.192l-0.261-1.801c-0.474-3.182-2.394-4.541-4.033-4.749 c-2.019-0.266-3.942,1.042-4.902,3.313C135.538,194.636,129.526,211.445,129.268,212.16z"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_58"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_57"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_56"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_55"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_54"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_53"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_52"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_51"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_49"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_48"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_47"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_46"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_44"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_43"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_42"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_41"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_40"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_39"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_38"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_37"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_36"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_35"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_34"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgressbarVertragUpload);
export default __webpack_public_path__ + "static/media/icon_progressbar_vertrag_upload.85f1a595582b0ccd029906ea1e1836ba.svg";
export { ForwardRef as ReactComponent };